export enum AssertExpressionType {
    ExpectTrue = 'expectTrue',
    ExpectUnique = 'expectUnique',
    ExpectExists = 'expectExists',
    ExpectCompare = 'expectCompare'
}

export enum MoveEntityType {
    TreeNode = 'treeNode',
    ConceptTree = 'conceptTree'
}

export class EnvironmentConstants {
    public static environmentKey: string = 'CICDEnvironment';
    public static devEnvironment: string = 'development';
    public static testEnvironment: string = 'test';
    public static prodEnvironment: string = 'production';
}

export class FactoryStagingPropConstants {
    public static stagingLSReferenceName: string = 'factoryStagingLSReferenceName';
    public static stagingLSType: string = 'factoryStagingLSType';
    public static stagingFolderPath: string = 'factoryStagingFolderPath';
}
